import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useNavigate, useLocation } from "react-router-dom";
import Toolbar from "../../componentes/toolbar/Toolbar";
import RenderTooltipCustom from "../../componentes/RenderTooltipCustom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RenderDateCustom from "../../componentes/RenderDateCustom";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { useDispatch, useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import moment from "moment";
import {
  archivarSolicitud,
  obtenerSolicitudes,
  setMessageError,
  setMessageSuccess,
  setSolicitudDetalle,
  setSolicitudes,
  validarSolicitudExistente,
} from "../../sliceRedux/ValidarReserva.slice";
import { nemonicoEstadoOpciones } from "../../constantes/appConstantes";
import ModalObservacion from "./ModalObservacion";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

const SolicitudesConstitución = () => {
  const toast = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const { codSolReservaDenominacion } = location.state || {};
  const navigate = useNavigate();
  const [bandejaSolicitudes, setBandejaSolicitudes] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const listaSolicitudes = useSelector((state) => state.validar.listaSolicitudes);
  const messageError = useSelector((state) => state.validar.messageError);
  const messageSuccess = useSelector((state) => state.validar.messageSuccess);
  const solicitudDetalle = useSelector((state) => state.validar.solicitudDetalle);
  const [modal, setModal] = useState(false);
  const [constitucion, setConstitucion] = useState(false);

  useEffect(() => {
    showLoader();
    dispatch(obtenerSolicitudes(codSolReservaDenominacion));
  }, []);

  useEffect(() => {
    if (listaSolicitudes.code === 200) {
      setBandejaSolicitudes(listaSolicitudes?.object ?? []);
    }

    return () => {
      hideLoader();
      dispatch(setSolicitudes({ ...listaSolicitudes, ...{ code: 0 } }));
    };
  }, [listaSolicitudes.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  useEffect(() => {
    if (messageSuccess != "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      modal && toggleModal();
      dispatch(obtenerSolicitudes(codSolReservaDenominacion));
    }
    return () => {
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (solicitudDetalle.code === 200) {
      navigate("/solicitudes-constitucion/nuevo", {
        state: { ...location.state, codSolConstitucion: null },
      });
    }
    return () => {
      hideLoader();
      dispatch(setSolicitudDetalle({ ...solicitudDetalle, ...{ code: 0 } }));
    };
  }, [solicitudDetalle.code]);

  const renderHeader = (
    <div className="flex justify-content-between">
      Solicitudes de Constitución
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText value={globalFilter} onChange={(e) => buscar(e)} placeholder="Buscar..." />
      </IconField>
    </div>
  );

  const buscar = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    if (value === "") {
      setBandejaSolicitudes([...(listaSolicitudes?.object ?? [])]);
      return;
    }

    const filtro = listaSolicitudes?.object?.filter((item) => {
      const fecEnvio = item.fecEnvio ? moment(item.fecEnvio).format("DD/MM/YYYY HH:mm:ss") : "";

      return (
        item.numSolicitud?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomCatTipoCaja?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomVinculoComun?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomParticular?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomEstadoSolicitud?.toUpperCase().includes(value.toUpperCase()) ||
        item.descVincComun?.toUpperCase().includes(value.toUpperCase()) ||
        fecEnvio.includes(value)
      );
    });

    setBandejaSolicitudes(filtro);
  };

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const actionTemplate = (rowData) => {
    return (
      <>
        {nemonicoEstadoOpciones.includes(rowData.nemCatEstadoSolicitud) ? (
          <>
            <Button
              icon="pi pi-pencil"
              rounded
              className="mr-2"
              tooltip="Editar"
              tooltipOptions={{ position: "top" }}
              onClick={() =>
                navigate("/solicitudes-constitucion/nuevo", {
                  state: {
                    ...location.state,
                    codSolConstitucion: rowData.codSolConstitucion,
                  },
                })
              }
            />
            <Button
              icon="pi pi-inbox"
              rounded
              className="mr-2"
              tooltip="Archivar"
              severity="warning"
              tooltipOptions={{ position: "top" }}
              onClick={() => {
                setConstitucion(rowData);
                toggleModal();
              }}
            />
          </>
        ) : (
          <Button
            icon="pi pi-file"
            rounded
            className="mr-2"
            tooltip="Revisar"
            tooltipOptions={{ position: "top" }}
            onClick={() => {
              navigate("/solicitudes-constitucion/revisar", {
                state: { ...location.state, codSolConstitucion: rowData.codSolConstitucion },
              });
            }}
          />
        )}
      </>
    );
  };

  const callbackArchive = (data) => {
    confirmDialog({
      message: "¿Está seguro que desea archivar la solicitud?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancelar",
      acceptLabel: "Aceptar",
      accept: () => {
        showLoader();
        dispatch(archivarSolicitud(data));
      },
      reject: null,
    });
  };

  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Toolbar>
          <div className="flex justify-content-between align-items-center">
            <div className="flex">
              <Button
                icon="pi pi-file-o"
                className="mr-2"
                label="Nueva solicitud"
                disabled={bandejaSolicitudes.length > 0}
                onClick={() => {
                  showLoader();
                  dispatch(validarSolicitudExistente(codSolReservaDenominacion));
                }}
              />
            </div>
          </div>
        </Toolbar>
        <DataTable
          header={renderHeader}
          className="p-datatable-responsive-demo"
          paginator
          rows={10}
          dataKey="codSolConstitucion"
          loading={undefined}
          value={bandejaSolicitudes}
          emptyMessage="Sin registros que mostrar."
          columnResizeMode="fit"
          style={{ width: "100%", overflow: "auto!important" }}
        >
          <Column
            body={rowIndexTemplate}
            header="Nro."
            sortable
            sortField="codSolConstitucion"
            headerStyle={{ textAlign: "center" }}
            style={{ width: "3%" }}
            bodyStyle={{
              textAlign: "center",
            }}
          />
          <Column
            field="numSolicitudReserva"
            header="Número único de solicitud de reserva"
            sortable
          />
          <Column
            field="razonSocial"
            header="Razón social"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.razonSocial)}
          />
          <Column
            field="tipoCaja"
            header="Tipo caja"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.tipoCaja)}
          />
          <Column
            field="vinculoComun"
            header="Tipo de vínculo común"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.vinculoComun)}
          />
          <Column
            field="descVincComun"
            header="Vínculo común"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.descVincComun)}
          />

          <Column
            field="fecEnvio"
            header="Fecha de envío"
            sortable
            headerStyle={{ textAlign: "center" }}
            body={(rowData) => RenderDateCustom(rowData.fecEnvio, 1)}
            bodyStyle={{ textAlign: "center", color: "hsl(206deg 100% 43%)" }}
          />
          <Column field="estadoSolicitud" header="Estado de la solicitud" sortable />
          <Column
            header="Acciones"
            headerStyle={{ textAlign: "center" }}
            bodyStyle={{
              textAlign: "center",
            }}
            style={{ width: "8%" }}
            body={actionTemplate}
          ></Column>
        </DataTable>
      </div>
      <ConfirmDialog />
      {modal && (
        <ModalObservacion
          modal={modal}
          toggleModal={toggleModal}
          callbackArchive={callbackArchive}
          codSolicitud={constitucion?.codSolConstitucion ?? 0}
        />
      )}
    </>
  );
};
export default SolicitudesConstitución;
